<header [class.scrolled]="isScrolled">
    <div class="content">
        <img class="logo" src="/assets/images/Logo farbig_transparent 3D.png" alt="">
        <nav class="menu">
            <ul>
                <li> <a href="#aboutme" [class.active-link]="activeSection === 'aboutme'"
                        (click)="setActive('aboutme')">{{
                        navText.about }}</a></li>
                <li><a href="#myskills" [class.active-link]="activeSection === 'myskills'"
                        (click)="setActive('myskills')">{{
                        navText.skills }}</a></li>
                <li><a href="#portfolio" [class.active-link]="activeSection === 'portfolio'"
                        (click)="setActive('portfolio')">{{
                        navText.portfolio }}</a></li>
                <div class="language">
                    <button [class.active]="currentLang === 'DE'" (click)="switchLang('DE')">DE</button>
                    <button [class.active]="currentLang === 'EN'" (click)="switchLang('EN')">EN</button>

                </div>
            </ul>
        </nav>

        <div class="burg-img" [class.animate-icon]="isBurgerOpen && !isClosing" (click)="openMenu()"></div>

        <div class="burger-menu" [class.open]="isBurgerOpen" [class.slide-out]="isClosing">
            <div class="top">
                <img class="logo" src="assets/images/Logo farbig_transparent 3D.png" alt="">
                <div class="language">
                    <button [class.active]="currentLang === 'DE'" (click)="switchLang('DE')">DE</button>
                    <button [class.active]="currentLang === 'EN'" (click)="switchLang('EN')">EN</button>
                </div>
                <div (click)="closeMenu()" class="animation" [class.animate-icon]="isBurgerOpen && !isClosing"></div>
            </div>

            <div class="links">
                <ul>
                    <li> <a (click)="closeMenu(); setActive('aboutme')" routerLink="/aboutme"
                            [class.active-link]="activeSection === 'aboutme'">{{ navText.about }}</a></li>
                    <li><a (click)="closeMenu(); setActive('myskills')" routerLink="/myskills"
                            [class.active-link]="activeSection === 'myskills'">{{ navText.skills }}</a></li>
                    <li><a (click)="closeMenu(); setActive('portfolio')" routerLink="/portfolio"
                            [class.active-link]="activeSection === 'portfolio'">{{ navText.portfolio }}</a></li>
                    <li><a (click)="closeMenu(); setActive('imprint')" routerLink="/imprint"
                            [class.active-link]="activeSection === 'imprint'">Imprint</a></li>
                    <li><a (click)="closeMenu(); setActive('contact')" routerLink="/contact"
                            [class.active-link]="activeSection === 'contact'">{{ navText.contact }}</a></li>
                </ul>
            </div>

        </div>

    </div>
</header>